import { render, staticRenderFns } from "./NoticePubDetails.vue?vue&type=template&id=37e0c126&scoped=true"
import script from "./NoticePubDetails.vue?vue&type=script&lang=js"
export * from "./NoticePubDetails.vue?vue&type=script&lang=js"
import style0 from "./NoticePubDetails.vue?vue&type=style&index=0&id=37e0c126&prod&scoped=true&lang=less"
import style1 from "./NoticePubDetails.vue?vue&type=style&index=1&id=37e0c126&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0c126",
  null
  
)

export default component.exports